export interface CreateSettingFlareInfo extends Record<string, unknown> {
  flareName: string;
  flareId: string;
  location: string;
  flareType: string;
  emission: string;
  unit: string;
  emissionFactor: string;
  remark: string;
  isActive: boolean;
}

export interface UpdateSettingFlareInfo extends CreateSettingFlareInfo {
  _id: string;
}

export interface ResponseSettingFlareInfo extends CreateSettingFlareInfo {
  _id: string;
}

export interface FilterSettingFlareInfo {
  flareName?: string[];
  flareId?: string[];
  location?: string[];
  flareType?: string[];
  page?: number;
  limit?: number;
}

export const flareTypeOptions = [
  { label: "Low Pressure Flare", value: "Low Pressure Flare" },
  { label: "High Pressure Flare", value: "High Pressure Flare" },
  { label: "Enclosed Ground Flare", value: "Enclosed Ground Flare" },
];

export const flareInfoUnitOptions = [{ label: "Kg/Kcal", value: "kg/kcal" }];
